import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import MunicipalityForm from '@/components/municipalities/MunicipalityForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import {
  MunicipalitiesActions,
  MunicipalityStoreState,
} from '@/stores/municipalities.store';
import { Municipality } from '@/models/municipality.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'MunicipalitiesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ms: MunicipalityStoreState }>();
const dataTables = computed<Municipality[]>(
  () => store.state.ms.municipalities,
);

const update = () => {
  store.dispatch(MunicipalitiesActions.GetMunicipalities);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editMunicipality = (_: Event, { item }: { item: Municipality }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(MunicipalityForm),
    data: item,
  });
};

const addMunicipality = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(MunicipalityForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '50%' },
  { title: 'Postal codes', key: 'postalCodes', width: '25%' },
  { title: 'On Site', key: 'impactRelevant', width: '10%' },
  { title: 'Date', key: 'creationDate', width: '10%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Municipalities", -1)),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editMunicipality,
        headers: headers,
        items: dataTables.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.postalCodes": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString([...value].splice(0, 5).join(', ')) + _toDisplayString(value.length > 5 ? '...' : ''), 1)
        ]),
        "item.impactRelevant": _withCtx(({ value }) => [
          value
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "mdi-check"
              }))
            : _createCommentVNode("", true),
          (!value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-circle-off-outline"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addMunicipality,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Municipality")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})